import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import './textInput.css';
/*
#tailwind
textInput textInput--outlined textInput--filled textInput--subtle textInput--success textInput--error 
textInput--warning textInput--default textInput--disabled 
*/

const TextInput = forwardRef(
  (
    {
      className,
      prefixIcon,
      suffixIcon,
      disabled,
      value,
      placeholder,
      context,
      size,
      mode,
      name,
      onChange,
      onBlur,
      ...other
    },
    ref
  ) => (
    <div
      className={bem`textInput--${{
        [size]: true,
        [context]: true,
        disabled,
        [mode]: true,
      }} ${className}`}
    >
      <div className="textInput_innerContainer">
        {prefixIcon}
        <input
          type="text"
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          ref={ref}
          {...other}
        />
      </div>
      {suffixIcon}
    </div>
  )
);

TextInput.propTypes = {
  className: PropTypes.string,
  prefixIcon: PropTypes.node,
  suffixIcon: PropTypes.node,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  context: PropTypes.oneOf(['error', 'warning', 'default']),
  mode: PropTypes.oneOf(['outlined', 'subtle']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

TextInput.defaultProps = {
  className: undefined,
  prefixIcon: undefined,
  suffixIcon: undefined,
  disabled: false,
  value: undefined,
  placeholder: undefined,
  context: 'default',
  size: 'medium',
  mode: 'outlined',
  name: undefined,
  onChange: undefined,
  onBlur: undefined,
};

export default TextInput;
